import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CallIcon from '@mui/icons-material/Call';
import Groups2Icon from '@mui/icons-material/Groups2';
import DoneIcon from '@mui/icons-material/Done';
import EngineeringIcon from '@mui/icons-material/Engineering';
// import "./CustomTimeLine.css"
const CustomTimeLine = () => {
    return(

    <>
       {/* <div className="container">
            <h4>Timeline Style : Demo-1</h4>
            <div className="row">
                <div className="col-md-12">
                    <div className="main-timeline">
                        <a href="#" className="timeline">
                            <div className="timeline-icon"><AccessTimeFilledIcon sx={{ fontSize: 100 }}  /></div>
                            <div className="timeline-content">
                                <h3 className="title">Web Designer</h3>
                                <p className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ducimus officiis quod! Aperiam eveniet nam nostrum odit quasi ullam voluptatum.
                                </p>
                            </div>
                        </a>
                        <a href="#" className="timeline">
                            <div className="timeline-icon"><i className="fa fa-rocket"></i></div>
                            <div className="timeline-content">
                                <h3 className="title">Web Developer</h3>
                                <p className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ducimus officiis quod! Aperiam eveniet nam nostrum odit quasi ullam voluptatum.
                                </p>
                            </div>
                        </a>
                        <a href="#" className="timeline">
                            <div className="timeline-icon"><i className="fa fa-briefcase"></i></div>
                            <div className="timeline-content">
                                <h3 className="title">Web Designer</h3>
                                <p className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ducimus officiis quod! Aperiam eveniet nam nostrum odit quasi ullam voluptatum.
                                </p>
                            </div>
                        </a>
                        <a href="#" className="timeline">
                            <div className="timeline-icon"><i className="fa fa-mobile"></i></div>
                            <div className="timeline-content">
                                <h3 className="title">Web Developer</h3>
                                <p className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ducimus officiis quod! Aperiam eveniet nam nostrum odit quasi ullam voluptatum.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div> */}
         <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="main-timeline2">
                        <div className="timeline">
                            <span className="icon fa fa-globe">
                            <CallIcon sx={{ 
                                fontSize: '80%', // Make the icon 100% of the parent container
                                width: '80%',
                                height: '80%',
                                }}  />
                            </span>

                            <a href="#" className="timeline-content">
                                <h3 className="title">Make Call</h3>
                                <p className="description">
                                    Connect with call for booking appointment to further step
                                </p>
                            </a>
                        </div>
                        <div className="timeline">
                            <span className="icon fa fa-rocket">
                            <Groups2Icon sx={{ 
                                fontSize: '80%', // Make the icon 100% of the parent container
                                width: '80%',
                                height: '80%',
                                }}  />
                            </span>
                            <a href="#" className="timeline-content">
                                <h3 className="title">Initial Discussion</h3>
                                <p className="description">
                                    Initial Discussion about purpose budget and other thinks.
                                </p>
                            </a>
                        </div>
                        <div className="timeline">
                            <span className="icon fa fa-briefcase">
                            <DoneIcon sx={{ 
                                fontSize: '80%', // Make the icon 100% of the parent container
                                width: '80%',
                                height: '80%',
                                }}  />
                            </span>
                            <a href="#" className="timeline-content">
                                <h3 className="title">Finalize the design</h3>
                                <p className="description">
                                    We Finalize the interior or exterior design for execution.
                                </p>
                            </a>
                        </div>
                        <div className="timeline">
                            <span className="icon fa fa-mobile">
                            <EngineeringIcon sx={{ 
                                fontSize: '80%', // Make the icon 100% of the parent container
                                width: '80%',
                                height: '80%',
                                }}  />
                            </span>
                            <a href="#" className="timeline-content">
                                <h3 className="title">Implementation</h3>
                                <p className="description">
                                    Start implementation after conformation of design by client
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr></hr>
    </>
    )
}

export default CustomTimeLine;